import { render, staticRenderFns } from "./ProspectPage.vue?vue&type=template&id=89c58fc4"
import script from "./ProspectPage.vue?vue&type=script&lang=js"
export * from "./ProspectPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports